// deps
import styled from "styled-components";

export const SavingsSectionWrapper = styled.div(({ theme }) => ({
    marginTop: theme.spacing.medium,
}));
